import React, { Fragment } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { theme, userDarkMode } from 'theme';
import { isPickupAndDelivery, isTakeaway } from 'submodules/OrderCore';
import { IRestaurant, TTableId } from 'features/home/types/homeTypes';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  label: {
    fontSize: 14,
    padding: 16,
    backgroundColor: theme.palette.grey[200],
    lineHeight: '2.4rem',
    color: theme.palette.grey[800],
    marginTop: 12,
    borderRadius: '4px',
    '& a': {
      textDecoration: 'none',
      color: userDarkMode ? '#00e6ff' : 'blue',
      '&:visited': {
        color: userDarkMode ? '#00e6ff' : 'blue',
      },
    },
  },
});
const TermsAndPolicyStep = ({
  tableId,
  restaurant,
}: {
  tableId: TTableId;
  restaurant: IRestaurant;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const isRenderTC = () => {
    if (isPickupAndDelivery(tableId)) {
      return false;
    } else if (isTakeaway(tableId) && restaurant.takeawayPayment) {
      return false;
    }
    return true;
  };

  return (
    <Typography className={classes.label}>
      <span>{t('By placing this order you accept the')}</span> <br />-{' '}
      <a href="https://orderbuddy.net.au/privacypolicy.html">{t('Data Processing Policy')}</a>
      <Fragment>
        <br />-{' '}
        <a href="https://orderbuddy.net.au/terms.html">{t('Restaurant Terms of Service')}</a>
        <br />
        <span>
          {t('This site is protected by reCAPTCHA and the Google')}{' '}
          <a href="https://policies.google.com/privacy">{t('Privacy Policy')}</a> {t('and')}{' '}
          <a href="https://policies.google.com/terms">{t('Terms of Service')}</a> {t('apply')}.
        </span>
      </Fragment>
    </Typography>
  );
};

export default TermsAndPolicyStep;
